import { useLocale } from '@gov-nx/core/service';
import { useProfilROSDetailContext } from '@gov-nx/module/page';
import { DataTable, Dialog, LayoutGap, Space } from '@gov-nx/ui/web';
import { toDateReadable } from '@gov-nx/utils/common';

export const EstablishmentsListModal = () => {
	const { isEstablishmentsListModalOpen, establishments, code } =
		useProfilROSDetailContext();
	const { t } = useLocale(code);

	return (
		<Dialog
			isOpen={isEstablishmentsListModalOpen.isTrue}
			onClose={isEstablishmentsListModalOpen.setFalse}
			title={<h3>{t('modal.label.provozovny')}</h3>}>
			<LayoutGap gap="m">
				{establishments.map((establishment) => (
					<LayoutGap
						key={establishment.icp}
						gap="s">
						<p>
							{t('modal.zaznam.icp')}
							<Space />
							{establishment?.icp ? establishment.icp : '-'}
						</p>
						<DataTable responsive>
							<tbody>
								<tr>
									<td className="sm:w-1/2">{t('modal.zaznam.adresa')}</td>
									<td className="sm:w-1/2">
										<strong>
											{establishment?.adresa?.adresaText
												? establishment.adresa.adresaText
												: '-'}
										</strong>
									</td>
								</tr>
								{establishment?.dorucovaciAdresa?.adresaText && (
									<tr>
										<td>{t('modal.zaznam.dorucovaci-adresa')}</td>
										<td>
											<strong>
												{establishment.dorucovaciAdresa.adresaText}
											</strong>
										</td>
									</tr>
								)}
								<tr>
									<td>{t('modal.zaznam.datum-zahajeni')}</td>
									<td>
										<strong>
											{establishment?.datumZahajeniCinnosti
												? toDateReadable(establishment.datumZahajeniCinnosti)
												: '-'}
										</strong>
									</td>
								</tr>
							</tbody>
						</DataTable>
					</LayoutGap>
				))}
			</LayoutGap>
		</Dialog>
	);
};
